import * as React from "react";
import { City } from "@models/city";
import { Button, Divider, Modal, Table, Avatar } from "antd";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import FormattedDateTime from "@components/custom/FormattedDateTime";
import Message from "@constants/message";
import CityForm from "@components/cities/Form";
import { PaginationDefaultParams } from "../custom/Paginator";
import { NavLink } from "react-router-dom";

type Props = {
  data: City[];
  loading: boolean;
  deleteFn: (item: City) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const CitiesTable: React.FC<Props> = props => {
  const { data, loading, currentPage, deleteFn, intl } = props;
  const { formatMessage } = intl;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;

  const deleteCity = (item: City): void => {
    Modal.confirm({
      content: formatMessage({
        id: "app.general_delete_warning",
        defaultMessage: Message.Warning.Delete
      }),
      okText: formatMessage({
        id: "app.delete",
        defaultMessage: "Delete"
      }),
      cancelText: formatMessage({
        id: "app.cancel",
        defaultMessage: "Cancel"
      }),
      className: "delete-confirm-dialog",
      onOk: () => deleteFn(item)
    });
  };

  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`} />,
      width: 30,
      dataIndex: "index",
      key: "id",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: <FormattedMessage id="app.name" defaultMessage={`Name`} />,
      width: 150,
      dataIndex: "name",
      key: "name"
    },
    {
      title: <FormattedMessage id="app.province" defaultMessage={`Province`} />,
      width: 150,
      dataIndex: "province",
      key: "province",
      render: (province, record) => province.name
    },
    {
      title: (
        <FormattedMessage
          id="app.creation_date"
          defaultMessage={`Creation Date`}
        />
      ),
      width: 120,
      dataIndex: "created_at",
      key: "created_at",
      render: (text, record) => <FormattedDateTime date={text} />
    },
    {
      title: "",
      key: "actions",
      width: 90,
      dataIndex: "actions",
      render: (text, record) => (
        <span>
          <NavLink to={`/cities/${record.id}/edit`}>
            <Button type="link" size={`small`}>
              <FormattedMessage id="app.edit" defaultMessage={`Edit`} />
            </Button>
          </NavLink>

          <Divider type="vertical" size={`small`} />

          <Button
            type="link"
            className={`danger`}
            onClick={() => deleteCity(record)}
          >
            <FormattedMessage id="app.delete" defaultMessage={`Delete`} />
          </Button>
        </span>
      )
    }
  ];

  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default injectIntl(CitiesTable);
